import { Tooltip } from "../Tooltip/Tooltip";

/**
 * Renders a title.
 * Generally used at the top of multiple related inputs
 */
export function InputGroupTitle(props: {
	title: string;
	tooltip?: string
}) {
	const {
		title,
		tooltip
	} = props;

	return (

		<div  className="input-group-title">
			<span>{title}</span>
			{tooltip && <Tooltip id={title} content={tooltip} place="bottom" />}
		</div>
	)
}